// types
import { createSlice } from '@reduxjs/toolkit';

const init_snackbar_state = {
  isOpen: false,
  message: '',
  color: '',
  closeAction: true
}

// initial state
const initialState = {
  snackBarState: {...init_snackbar_state},
}

const errorsSlice = createSlice({
  name: 'errors',
  initialState,
  reducers: {
    showErrorSnackBar(state, action) {
      const message = action.payload;
      console.log(message);
      const newState = {
        isOpen: true,
        message: message,
        color: 'red',
        closeAction: true
      }
      state.snackBarState = {...init_snackbar_state, ...newState};
    },
    closeSnackBar(state, action) {
      state.snackBarState = {...init_snackbar_state };
    }
  },

});

export const { showErrorSnackBar, closeSnackBar  } = errorsSlice.actions;
export default errorsSlice.reducer;
